import WOW from "wow.js";

$.fn.isInViewport = function () {
  let elementTop = $(this).offset().top;
  let elementHeight = $(this).innerHeight();
  let elementBottom = elementTop + $(this).outerHeight() + 60;

  let viewportTop = $(window).scrollTop();
  let viewportBottom = viewportTop + $(window).height() + 60;

  const windowHeight = $(window).height();

  // return elementBottom > viewportTop && elementTop < viewportBottom;

  return (
    viewportTop >= elementTop - windowHeight / 3 &&
    viewportTop < elementTop + elementHeight / 2
  );
};

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

$(function () {
  let timeOutStickyMenu;

  const sections = {
    init() {
      this.initSideControlMenu();
    },
    initNumbers() {
      const _this = this;

      // Init countdown
      $("[data-count-number]").each(function () {
        const self = $(this);
        const value = self.data("count-number");

        const arrValue = `${value}`.split("");
        let html = "";
        arrValue.forEach(function (item, index) {
          if (item !== ",") {
            html += `<span class="number" data-target-number="${item}" data-delay="${
              index * 100
            }"><span class="placeholder">0</span></span>`;
          } else {
            html += `<span class="comma">,</span>`;
          }
        });

        self.prepend(html);
      });

      // Init
      const _ele = $("[data-numbers]");
      let _elePosition = 0;
      let _st = 0;
      let _windowHeight = 0;

      (_st = $(window).scrollTop()), (_windowHeight = $(window).innerHeight());

      if (_ele.length > 0) {
        if ($(".page-template-about").length) {
          _ele.each(function (index, el) {
            _elePosition = $(this).offset().top + $(this).outerHeight();
            if (_windowHeight - _elePosition) {
              $(".inline-figure-figures").each(function () {
                const self = $(this);

                if (!self.hasClass("animating")) {
                  self.addClass("animating");
                  const numbers = self.find(".number");

                  numbers.each(function () {
                    const number = $(this);
                    self.addClass("animating");
                    _this.countdownForSpecificNumber(number, numbers.length);
                  });
                }
              });
            } else {
              $(".animating").removeClass("animating");
              $(".number.char-1").removeClass("char-1");
              $(".number.char-2").removeClass("char-2");
              $(".number.char-3").removeClass("char-3");
              $(".number.char-4").removeClass("char-4");
              $(".number.char-5").removeClass("char-5");
              $(".number.char-6").removeClass("char-6");
              $(".number.char-7").removeClass("char-7");
              $(".number.char-8").removeClass("char-8");
              $(".number.char-9").removeClass("char-9");
              $(".number.char-dot").removeClass("char-dot");
              $(".number.char-comma").removeClass("char-comma");
              $(".number .animate-number").remove();
              if (!$(".number").find(".placeholder").length) {
                $(".number").append(`<span class="placeholder">0</span>`);
              }
            }
          });
        } else {
          _ele.each(function (index, el) {
            _elePosition = $(this).offset().top + $(this).outerHeight();
            if (
              $(this).offset().top + $(this).outerHeight() <
                _windowHeight + _st &&
              _elePosition > _st
            ) {
              $(".inline-figure-figures").each(function () {
                const self = $(this);

                if (!self.hasClass("animating")) {
                  self.addClass("animating");
                  const numbers = self.find(".number");

                  numbers.each(function () {
                    const number = $(this);
                    self.addClass("animating");
                    _this.countdownForSpecificNumber(number, numbers.length);
                  });
                }
              });
            } else {
              $(".animating").removeClass("animating");
              $(".number.char-1").removeClass("char-1");
              $(".number.char-2").removeClass("char-2");
              $(".number.char-3").removeClass("char-3");
              $(".number.char-4").removeClass("char-4");
              $(".number.char-5").removeClass("char-5");
              $(".number.char-6").removeClass("char-6");
              $(".number.char-7").removeClass("char-7");
              $(".number.char-8").removeClass("char-8");
              $(".number.char-9").removeClass("char-9");
              $(".number.char-dot").removeClass("char-dot");
              $(".number.char-comma").removeClass("char-comma");
              $(".number .animate-number").remove();
              if (!$(".number").find(".placeholder").length) {
                $(".number").append(`<span class="placeholder">0</span>`);
              }
            }
          });
        }
      }

      $(window).scroll(function () {
        const _ele = $("[data-numbers]");
        let _elePosition = 0;
        let _st = 0;
        let _windowHeight = 0;

        (_st = $(window).scrollTop()),
          (_windowHeight = $(window).innerHeight());

        if (_ele.length > 0) {
          if ($(".page-template-about").length) {
            _ele.each(function (index, el) {
              _elePosition = $(this).offset().top + $(this).outerHeight();
              if (_windowHeight + _st - _elePosition < $(this).outerHeight()) {
                $(".inline-figure-figures").each(function () {
                  const self = $(this);

                  if (!self.hasClass("animating")) {
                    self.addClass("animating");
                    const numbers = self.find(".number");

                    numbers.each(function () {
                      const number = $(this);
                      self.addClass("animating");
                      _this.countdownForSpecificNumber(number, numbers.length);
                    });
                  }
                });
              } else {
                $(".animating").removeClass("animating");
                $(".number.char-1").removeClass("char-1");
                $(".number.char-2").removeClass("char-2");
                $(".number.char-3").removeClass("char-3");
                $(".number.char-4").removeClass("char-4");
                $(".number.char-5").removeClass("char-5");
                $(".number.char-6").removeClass("char-6");
                $(".number.char-7").removeClass("char-7");
                $(".number.char-8").removeClass("char-8");
                $(".number.char-9").removeClass("char-9");
                $(".number.char-dot").removeClass("char-dot");
                $(".number.char-comma").removeClass("char-comma");
                $(".number .animate-number").remove();
                if (!$(".number").find(".placeholder").length) {
                  $(".number").append(`<span class="placeholder">0</span>`);
                }
              }
            });
          } else {
            _ele.each(function (index, el) {
              _elePosition = $(this).offset().top + $(this).outerHeight();
              if (
                $(this).offset().top + $(this).outerHeight() <
                  _windowHeight + _st &&
                _elePosition > _st
              ) {
                $(".inline-figure-figures").each(function () {
                  const self = $(this);

                  if (!self.hasClass("animating")) {
                    self.addClass("animating");
                    const numbers = self.find(".number");

                    numbers.each(function () {
                      const number = $(this);
                      self.addClass("animating");
                      _this.countdownForSpecificNumber(number, numbers.length);
                    });
                  }
                });
              } else {
                $(".animating").removeClass("animating");
                $(".number.char-1").removeClass("char-1");
                $(".number.char-2").removeClass("char-2");
                $(".number.char-3").removeClass("char-3");
                $(".number.char-4").removeClass("char-4");
                $(".number.char-5").removeClass("char-5");
                $(".number.char-6").removeClass("char-6");
                $(".number.char-7").removeClass("char-7");
                $(".number.char-8").removeClass("char-8");
                $(".number.char-9").removeClass("char-9");
                $(".number.char-dot").removeClass("char-dot");
                $(".number.char-comma").removeClass("char-comma");
                $(".number .animate-number").remove();
                if (!$(".number").find(".placeholder").length) {
                  $(".number").append(`<span class="placeholder">0</span>`);
                }
              }
            });
          }
        }
      });
    },
    countdownForSpecificNumber(a, total) {
      // console.log('%ccounted-sections.js line:30 running', 'color: #007acc;');
      const delay = a.data("delay") ? parseInt(a.data("delay")) : 0;
      setTimeout(() => {
        var f = a.data("target-number"),
          habc = a.find(".placeholder"),
          g = 0;
        habc.addClass("go-out");

        habc.one("transitionend", function () {
          habc.remove();
        });

        var k = window.setInterval(function () {
          var h = $(
            `<span class="animate-number">${Math.floor(
              10 * Math.random()
            )}</span>`
          );
          a.append(h);
          g > 5
            ? (window.clearInterval(k),
              h.addClass("slow"),
              window.setTimeout(function () {
                if (!a.find(".animate-number.final").length) {
                  const b = `<span class="animate-number final">${f}</span>`;
                  a.append(b);
                }
                let classF = `char-${f}`;
                if (f === ",") {
                  classF = "char-comma";
                }
                if (f === ".") {
                  classF = "char-dot";
                }
                a.addClass(`animated ${classF}`);
              }, 100))
            : h.addClass("blur");

          h.one("animationend", function () {
            h.remove();
          });

          // h.one("transitionend", function () {
          //   h.remove();
          // });

          g += 1;
        }, 100);

        let countBlur = 0;
        var kBlur = window.setInterval(function () {
          if (countBlur === 5) {
            window.clearInterval(kBlur);
          } else {
            a.find(".animate-number.blur").eq(countBlur).addClass("show");
          }

          countBlur += 1;
        }, 100);
      }, 1000 + delay);
    },
    initSideControlMenu() {
      const _this = this;

      if ($("[data-side-control-menu]").length) {
        $("[data-side-control-menu]").remove();
      }

      let firstCountedSection = "";
      let secondCountedSection = "";
      let itemsHTML = "";

      $("[data-counted-sections]").each(function (idx) {
        const self = $(this);
        const id = self.attr("id");
        const title = self.data("section-title");

        if (id && title) {
          if (idx === 0) {
            firstCountedSection = id;
          }

          if (idx === 1) {
            secondCountedSection = id;
          }

          itemsHTML += `<li data-item="" data-id="${id}" class="${
            idx === 0 ? "active" : ""
          }">
              <a href="#${id}">
                  <span data-item-title="">${title}</span>
              </a>
            </li>`;
        }
      });

      const style = $(window).width() <= 1280 ? "display: none;" : "";
      $("body").append(`<ul data-side-control-menu="" style="${style}">
          ${itemsHTML}
        </ul>`);

      // Scrolling
      // Cache selectors
      var lastId,
        topMenu = $("[data-side-control-menu]"),
        // All list items
        menuItems = topMenu.find("a"),
        // Anchors corresponding to menu items
        scrollItems = menuItems.map(function () {
          var item = $($(this).attr("href"));
          if (item.length) {
            return item;
          }
        });

      // Bind click handler to menu items
      // so we can get a fancy scroll animation
      menuItems.click(function (e) {
        e.preventDefault();

        // Moengage: CategoryClick
        const category = $(this).find("[data-item-title]").text();

        if (category && Moengage) {
          Moengage?.track_event("CategoryClick", {
            Category: category.replace(/\n|\r|\t/g, ""),
          });
        }

        const href = $(this).attr("href");
        let offsetTop =
          href === "#" ? 0 : $(href).offset().top - $("header").height();

        const w = $(window).width();

        $("[data-side-control-menu] .active").removeClass("active");
        $(this).parent().addClass("active");

        $("html, body").stop().animate(
          {
            scrollTop: offsetTop,
          },
          850
        );
      });

      $(window).scroll(function () {
        const w = $(window).width();

        scrollItems.each(function () {
          const section = $(this);
          const id = section.attr("id");

          if (section.isInViewport()) {
            $("[data-side-control-menu] .active").removeClass("active");
            $(`[data-side-control-menu] [data-id="${id}"]`).addClass("active");
          }
        });

        const _ele = $(".numbers");
        let _elePosition = 0;
        let _st = 0;
        let _windowHeight = 0;

        (_st = $(window).scrollTop()),
          (_windowHeight = $(window).innerHeight());

        const spTop =
          $(`#${firstCountedSection}`).length &&
          $(`#${firstCountedSection}`).offset().top
            ? $(`#${firstCountedSection}`).offset().top - $("header").height()
            : 200;
        if (
          $(`#${firstCountedSection}`).length &&
          _st > spTop &&
          firstCountedSection &&
          w <= 1280
        ) {
          $("[data-side-control-menu]").stop().fadeIn();
        } else {
          if (w <= 1280) {
            $("[data-side-control-menu]").stop().fadeOut();
          }
        }

        if (
          $(`#${firstCountedSection}`).length &&
          $(`#${secondCountedSection}`).length &&
          _st > spTop &&
          _st < $(`#${secondCountedSection}`).offset().top &&
          firstCountedSection &&
          secondCountedSection
        ) {
          if (!$(`#${secondCountedSection}`).hasClass("counted")) {
            $("[data-side-control-menu]").addClass("hover");
          }

          // Turn to line state after 5s
          if (
            !timeOutStickyMenu &&
            !$(`#${secondCountedSection}`).hasClass("counted")
          ) {
            timeOutStickyMenu = setTimeout(function () {
              $("[data-side-control-menu]").removeClass("hover");
              $(`#${secondCountedSection}`).addClass("counted");
            }, 5000);
          }
        } else {
          $("[data-side-control-menu]").removeClass("hover");
        }
      });

      const _st = $(window).scrollTop();
      const w = $(window).width();

      if (
        $(`#${firstCountedSection}`).length &&
        _st >
          $(`#${firstCountedSection}`).offset().top - $("header").height() &&
        firstCountedSection &&
        w <= 1280
      ) {
        $("[data-side-control-menu]").stop().fadeIn();
      }

      // gsap.registerPlugin(ScrollTrigger);
      const h = $(window).height();
      var pinAmount = w > 767 ? 210 : 276;
      let start = w > 767 ? "bottom bottom" : "top top";

      const hPanels = $("section.fancy .panel").length * 210;
      let hContainer =
        w > 767
          ? h - 210 > 630
            ? hPanels > 630
              ? 630
              : hPanels
            : h - 210
          : h - 95;

      function resize() {
        const w = $(window).width();
        const hPanels = $("section.fancy .panel").length * 210;
        pinAmount = w > 767 ? 210 : 276;

        hContainer =
          w > 767
            ? h - 210 > 630
              ? hPanels > 630
                ? 630
                : hPanels
              : h - 210
            : h - 95;

        $("[data-scroll-inner]").css({
          height:
            w > 767
              ? h - 210 > 630
                ? hPanels > 630
                  ? 630
                  : hPanels
                : h - 210
              : h - 95,
        });

        if (w > 1280) {
          $("[data-side-control-menu]").stop().fadeIn();
        }
      }

      resize();

      if ($("#main_wrapper section.fancy .panel").length > 3) {
        ScrollTrigger.addEventListener("refreshInit", resize);

        let introLoading = true;
        var horizontal_scroll_tl = gsap.timeline({
          scrollTrigger: {
            trigger: "section.fancy",
            scrub: 0.5,
            pin: "#main_wrapper",
            start,
            end: () => `+=${pinAmount * 5}`,
          },
          duration: 0,
        });

        horizontal_scroll_tl.to("section.fancy .container", {
          y: -(pinAmount * 5 - hContainer),
          ease: "none",
        });
      }
    },
  };

  if ($("[data-count-number]").length) {
    sections.initNumbers();
  }

  if ($("[data-counted-sections]").length) {
    sections.init();

    const loop = document.getElementById("loop_js");
    const oriLength = $(".loop_js li").length;

    if (loop) {
      const loopAnim = new TimelineMax({
        repeat: -1,
      });

      let loopItem = (window.innerWidth, loop.children[0]);
      loop.appendChild(loopItem.cloneNode(true));
      loop.appendChild(loopItem.cloneNode(true));

      loopAnim
        .to(loop, $(".loop_js li").length * 4, {
          ease: Power0.easeNone,
          yPercent: -66.66666,
        })
        .to(loop, 0, { ease: Power0.easeNone, y: 0 });

      if ($(window).width() < 768) {
        loopAnim.pause();
      }

      $("#abc").on("mouseenter", function () {
        loopAnim.pause();
      });

      $("#abc").on("mouseleave", function () {
        loopAnim.play();
      });

      $(window).on("resize", function () {
        if ($(window).width() < 768) {
          loopAnim.pause();
        } else {
          loopAnim.play();
        }
      });
    }
  }
});
